"use client"

import { Divider } from "@heroui/divider"

export default function PageClient() {
  const handleClick = () => {
    window.open(
      "https://docs.google.com/document/d/1pdZE7u5LBh9wjSmSZhxUAF2YfiEJgKEZEF5XC_a1dwg/edit?tab=t.0",
      "_blank"
    )
  }
  const handleHelpClick = () => {
    window.open(
      "https://docs.google.com/document/d/1prRWnRLYtnIIeCkAPYTImvt7Qv7oQOaywhLBqv675L0/edit?tab=t.0",
      "_blank"
    )
  }
  return (
    <div className="p-3 text-[#1D2129] sm:px-[64px] sm:pt-[40px]">
      <h1 className="mb-1 text-[24px] font-bold sm:text-[36px]">
        SnapThePrice Rewards
      </h1>
      <div className="mb-5">
        Welcome to SnapThePrice Rewards – our way of giving back to our users.
        By using SnapThePrice, you not only save money but also earn real
        rewards.
      </div>
      <div className="mb-3 text-[20px] font-bold sm:text-[24px]">
        Quick Guide
      </div>
      <div className="mb-2 ml-[33px] flex font-bold">
        <div className="w-[20%]">Step</div>
        <div className="w-[30%]">Action</div>
        <div className="w-[30%]">Reward</div>
        <div className="w-[20%]">Notes / Rules</div>
      </div>
      <div className="mb-1">
        <Divider />
      </div>
      {/* <div className="mb-1 flex items-center">
        <div className="mx-3 font-bold">1</div>
        <div className="w-[20%]">Sign Up</div>
        <div className="w-[30%]">Register a SnapThePrice account</div>
        <div className="w-[30%]">$5 cash reward</div>
        <div className="w-[20%]">Credited instantly; Available to Cash Out</div>
      </div>
      <div className="mb-1">
        <Divider />
      </div> */}
      <div className="mb-1 flex items-center">
        <div className="mx-3 font-bold">1</div>
        <div className="w-[20%]">Install Chrome Extension</div>
        <div className="w-[30%]">Install SnapThePrice for the first time</div>
        <div className="w-[30%]">$5 cash reward</div>
        <div className="w-[20%]">
          Starts as Pending, becomes Payable after 10 days of active use
        </div>
      </div>
      <div className="mb-1">
        <Divider />
      </div>
      <div className="mb-1 flex items-center">
        <div className="mx-3 font-bold">2</div>
        <div className="w-[20%]">Daily Snap</div>
        <div className="w-[30%]">
          Use SnapThePrice to find lowest-price offers
        </div>
        <div className="w-[30%]">$0.05 per Snap</div>
        <div className="w-[20%]">
          Maximum 20 rewarded Snaps/day → $1/day; activity updated next day
        </div>
      </div>
      <div className="mb-1">
        <Divider />
      </div>
      <div className="mb-1 flex items-center">
        <div className="mx-3 font-bold">3</div>
        <div className="w-[20%]">Use AI Assistant</div>
        <div className="w-[30%]">
          Interact with ChatGPT-powered AI Assistant
        </div>
        <div className="w-[30%]">Counts toward 10-day active usage</div>
        <div className="w-[20%]">
          Daily use helps convert Pending rewards to Payable
        </div>
      </div>
      <div className="mb-1">
        <Divider />
      </div>
      <div className="mb-1 flex items-center">
        <div className="mx-3 font-bold">4</div>
        <div className="w-[20%]">Invite Friends</div>
        <div className="w-[30%]">Share your personal referral link</div>
        <div className="w-[30%] pr-2">
          $2 Pending Reward for inviter and $5 Pending Reward for friend
        </div>
        <div className="w-[20%]">
          Reward converts to Payable after friend completes 10 days active usage
        </div>
      </div>
      <div className="mb-1">
        <Divider />
      </div>
      <div className="mb-1 flex items-center">
        <div className="mx-3 font-bold">5</div>
        <div className="w-[20%]">Redeem Rewards</div>
        <div className="w-[30%]">Cash out via PayPal or Amazon Gift Card</div>
        <div className="w-[30%]">Available when balance ≥ $20</div>
        <div className="w-[20%]">
          Bind U.S. PayPal account or select Amazon Gift Card; rewards never
          expire
        </div>
      </div>
      <div className="mb-1">
        <Divider />
      </div>
      <div className="mb-1 flex items-center">
        <div className="mx-3 font-bold">6</div>
        <div className="w-[20%]">Compliance</div>
        <div className="w-[30%]">
          Ensure ≥70% Snap/Chat activity is from U.S. IPs
        </div>
        <div className="w-[30%]">Rewards valid and payable</div>
        <div className="w-[20%]">
          Multiple accounts on same device are not eligible
        </div>
      </div>
      <div className="mb-[40px]">
        <Divider />
      </div>
      <div className="mb-2 font-bold sm:text-[20px]">keynotes</div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">Rewards policies apply only to U.S. users.</li>
        <li className="mb-2">
          Pending rewards automatically convert to Payable after meeting 10-day
          activity requirement.
        </li>
        <li className="mb-2">
          Rewards are credited daily in your dashboard, but may take the next
          day to reflect.
        </li>
        <li className="mb-[40px]">
          Each device ID can only claim rewards for the first registered
          account.
        </li>
      </ul>
      <h1 className="mb-1 text-[24px] font-bold sm:text-[36px]">
        SnapThePrice Rewards Policy
      </h1>
      <div className="mb-1 text-[#F53F3F]">
        Effective Area: United States Only
      </div>
      <div className="mb-5 text-[#F53F3F]">
        ⚠️ All rewards policies and cashout rules described below apply only to
        users located within the United States.
      </div>
      <div className="mb-3 text-[20px] font-bold sm:text-[24px]">
        1. How to Earn Rewards
      </div>
      <div className="mb-2 font-bold">1.1 New User Rewards</div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">
          a. Sign-Up Bonus:
          <br /> New users receive an instant $5 cash reward upon registration.
          This reward is immediately marked as Available to Cash Out.
        </li>
        <li className="mb-2">
          b. Installation Bonus:
          <br /> Users who install the SnapThePrice Chrome extension for the
          first time will receive an additional $5 cash reward. This reward
          starts in a Pending status and becomes Available to Cash Out once the
          user completes 10 days of active usage.
          <br />
          Active usage means interacting with SnapThePrice’s core features for
          at least one of the following actions per day:
        </li>
        <li className="mb-2 ml-4">
          Using the Snap function to find the lowest product offer and viewing
          its details
        </li>
        <li className="mb-5 ml-4">
          USing the AI Assistant to chat and train the personalized shopping
          assistant powered by ChatGPT.
        </li>
      </ul>
      <div className="mb-2 font-bold">1.2 Daily Snap Rewards</div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">
          Earn $0.05 for every successful product Snap when you use SnapThePrice
          to find the lowest prices.
        </li>
        <li className="mb-2 ml-4">
          There is no limit to how many Snaps you can perform per day.
        </li>
        <li className="mb-2 ml-4">
          However, the rewarded Snaps are capped at 20 Snaps per day, meaning
          you can earn up to $1.00 per day.
        </li>
        <li className="mb-5 ml-4">
          Snap activity and Rewards data will be updated in your account
          dashboard on the following day.
        </li>
      </ul>
      <div className="mb-2 font-bold">1.3 Referral Rewards</div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">Invite your friends and earn together!</li>
        <li className="mb-2 ml-4">
          Each registered user can find a personal referral link on the Rewards
          page.
        </li>
        <li className="mb-2 ml-4">
          When someone registers using your referral link:
        </li>
        <li className="mb-2 ml-8">
          Both you and the new user receive a $5 Pending Reward.
        </li>
        <li className="mb-5 ml-8">
          Once the referred user completes 10 days of active usage, both
          accounts’ rewards change from Pending to Available to Cash Out.
        </li>
      </ul>
      <div className="mb-3 text-[20px] font-bold sm:text-[24px]">
        2. Reward Forms
      </div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">
          Rewards can be redeemed in either of the following formats:
        </li>
        <li className="mb-2 ml-4">Cash via PayPal (U.S. accounts only)</li>
        <li className="mb-5 ml-4">Amazon Gift Card (equal cash value)</li>
      </ul>
      <div className="mb-3 text-[20px] font-bold sm:text-[24px]">
        3. Redemption Rules
      </div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">
          Minimum Cash-Out Amount: $20 in “Available to Cash Out” balance.
        </li>
        <li className="mb-2">
          How to Redeem:
          <br /> Once your available rewards reach $20, you can submit a
          cash-out request from the Rewards Page. After verification by the
          SnapThePrice team, the payment will be processed.
        </li>
        <li className="mb-2">Payment Methods:</li>
        <li className="mb-2 ml-4">
          Link your U.S. PayPal account to receive cash payments, or
        </li>
        <li className="mb-2 ml-4">
          Select Amazon Gift Card as your preferred redemption option.
        </li>
        <li className="mb-5">
          Reward Validity: All earned rewards remain valid indefinitely.
        </li>
      </ul>
      <div className="mb-3 text-[20px] font-bold sm:text-[24px]">
        4. Restrictions and Compliance
      </div>
      <div className="mb-2">Anti-Fraud Policy</div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">
          During the 10-day activity period for new users, at least 70% of total
          Snap/Chat interactions must originate from U.S.-based IP addresses.
        </li>
        <li className="mb-2 ml-4">
          Rewards that meet this criterion will be considered valid and payable.
        </li>
        <li className="mb-2 ml-4">
          Rewards that do not meet this criterion will be marked as invalid and
          non-redeemable.
        </li>
      </ul>
      <div className="mb-2">Abuse Limitation</div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">
          Only the first registered account per device ID is eligible for the
          rewards described above. Any additional accounts created on the same
          device will not qualify for rewards.
        </li>
      </ul>
      <div className="mb-2">Geographic Limitation</div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-5">
          SnapThePrice Rewards Program is available only to users located in the
          United States.
        </li>
      </ul>
      <div className="mb-3 text-[20px] font-bold sm:text-[24px]">
        5. User Support
      </div>
      <ul className="list-disc pl-5 text-[14px]">
        <li className="mb-2">
          For any questions about Rewards or Cash Out, please:
        </li>
        <li className="mb-2 ml-4">
          Visit our{" "}
          <span
            onClick={handleClick}
            className="cursor-pointer text-[#135BFF] underline"
          >
            FAQ
          </span>{" "}
          or{" "}
          <span
            onClick={handleHelpClick}
            className="cursor-pointer text-[#135BFF] underline"
          >
            Cashout Tutorial
          </span>
          , or
        </li>
        <li className="mb-6 ml-4">
          Contact us at support@snaptheprice.com.
          <br />
          Our support team will respond as soon as possible.
        </li>
      </ul>
      <div className="text-[14px] text-[#F53F3F]">
        Note: All rewards policies and cashout rules listed above apply
        exclusively to U.S. users and are subject to SnapThePrice’s final
        interpretation and adjustment.
      </div>
    </div>
  )
}
